export enum PaymentStatus {
  PAID = 'PAID',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
}

export enum ArticleStatus {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED',
}

export enum UserStatus {
  SUSPENDED = 'SUSPENDED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export enum PackageStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum TemporaryAccessCodeStatus {
  ENABLED = 'Enabled',
  DISABLED = 'Disabled',
}

export enum AuthStatus {
  pending,
  signedIn,
  signedOut,
}

export enum PackageRequestStatus {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export enum MessageDeliveryStatus {
  SENT = 'submitted',
  DELIVERED = 'delivered',
  REJECTED = 'rejected',
  READ = 'read',
  RECEIVED = 'received',
  SCHEDULED = 'SCHEDULED',
}
export enum MessageStatusEnums {
  SENT = 'SENT',
  REJECTED = 'REJECTED',
  CLOCK = 'CLOCK',
  READ = 'READ',
  DELIVERED = 'DELIVERED',
  SCHEDULED = 'SCHEDULED',
}
